import {FC, useMemo} from 'react';

import {DoorsList} from '@mavismart_frontend/pages/tabs/doors_list';
import {useAllDoors} from '@mavismart_frontend/stores/all_doors_store';

export const AllDoorsList: FC = () => {
  const allDoors = useAllDoors();
  const allDoorIds = useMemo(
    () => (allDoors?.doors ? [...allDoors.doors.keys()] : undefined),
    [allDoors]
  );

  return <DoorsList doorIds={allDoorIds} />;
};

AllDoorsList.displayName = 'AllDoorsList';
